export const DESIGN_02 = {
 "blocks": [
    {
      "blockType": "NAVBAR",
      "blockDesign": "NavDesign1",
      "editFormName": "NAVBAR_FORM_1",
      "styleProps": {
        "background-color": "#E4ECFA"
      },
      "logoType": "text",
      "logoImg": {
        "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
        "altText": "FlexBee",
        "styleProps": {
          "height": "3rem"
        }
      },
      "logoText": {
        "text": "✦ Sonic",
        "styleProps": {
          "font-size": "1.875rem",
          "color": "#333333",
          "font-family": "'Lato', sans-serif",
          "line-height": "2.25rem",
          "font-family-bk": "'Lato', sans-serif",
          "font-weight": "900"
        },
        "stylePropsMob": {},
        "stylePropsTab": {}
      },
      "logoHTML": {
        "html": "FlexBee",
        "styleProps": {
          "font-size": "1.875rem",
          "color": "#ffffff",
          "font-family": "'Oswald', sans-serif",
          "line-height": "2.25rem"
        },
        "stylePropsMob": {},
        "stylePropsTab": {}
      },
      "links": [
        {
          "text": "Features",
          "linkUrl": "/features",
          "styleProps": {
            "color": ""
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Services",
          "linkUrl": "/services",
          "styleProps": {
            "color": ""
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Docs",
          "linkUrl": "/docs",
          "styleProps": {
            "color": ""
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Pricing",
          "linkUrl": "/pricing",
          "sectionID": "aboutsection",
          "styleProps": {
            "color": "",
            "margin": "0px 0px 0px 120px"
          }
        },
        {
          "text": "Get Started",
          "linkUrl": "/home",
          "sectionID": "aboutsection",
          "styleProps": {
            "color": "#ffffff",
            "border-width": "0px",
            "border-radius": "9999px",
            "padding": "14px 30px 14px 30px",
            "margin": "0px 0px 0px 20px",
            "border-color": "#4f4f4f",
            "background-color": "#2862E9"
          }
        }
      ],
      "hamburgerStyleProps": {
        "color": "#333333",
        "border-color": "#333333"
      },
      "metaDataId": 1747644974639,
      "afterIndex": -1,
      "blockId": 1747644974639,
      "linksStyleProps": {
        "color": "#333333",
        "padding": "14px 0px 14px 0px",
        "font-weight": "700",
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    },
    {
      "blockType": "HEADER",
      "blockDesign": "header_01",
      "styleProps": {
        "background-image": "url('')",
        "background-color": "#ffffff",
        "padding": "60px 20px 60px 20px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#ececec"
      },
      "position": "center",
      "headingsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center",
        "max-width": "896px",
        "margin": "4px auto 4px auto"
      },
      "headingsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "headingsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "headings": [
        {
          "styleProps": {
            "font-size": "1.25rem",
            "line-height": "1.75rem",
            "padding": "12px 20px 12px 20px",
            "font-weight": "400",
            "color": "#ffffff",
            "font-family-cust": "",
            "font-family": "'Lato', sans-serif",
            "margin": "0px 0px 0px 0px",
            "font-family-bk": "'Lato', sans-serif",
            "background-color": "#262626",
            "border-radius": "1.5rem"
          },
          "stylePropsTab": {
            "font-size": "1.25rem",
            "line-height": "1.75rem",
            "padding": "20px 20px 20px 20px"
          },
          "stylePropsMob": {
            "font-size": "1.125rem",
            "line-height": "1.75rem",
            "padding": "20px 20px 20px 20px"
          },
          "text": "☆ Top 10 from over 100+ developers",
          "alignStyleProps": {
            "text-align": "center"
          }
        },
        {
          "text": "Exceptional Talent, Unmatched Expertise",
          "styleProps": {
            "font-size": "4.5rem",
            "line-height": "1",
            "padding": "20px 0px 40px 0px",
            "font-weight": "600",
            "color": "#333333",
            "font-family-cust": "",
            "font-family": "'Lato', sans-serif",
            "margin": "0px 0px 0px 0px",
            "font-family-bk": "'Lato', sans-serif"
          },
          "stylePropsTab": {
            "font-size": "3rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "2.25rem",
            "line-height": "2.5rem"
          }
        },
        {
          "text": "Collectively, our top 10 developers have 500+ years of experience, 1000+ GitHub contributions, and a 95%+ client retention rate.",
          "styleProps": {
            "font-size": "1.5rem",
            "line-height": "2rem",
            "color": "#333333",
            "margin": "0px 0px 0px 0px",
            "font-family": "'Lato', sans-serif",
            "font-weight": "400",
            "padding": "20px 0px 40px 0px"
          },
          "stylePropsTab": {
            "font-size": "1.25rem",
            "line-height": "1.75rem"
          },
          "stylePropsMob": {
            "font-size": "1.25rem",
            "line-height": "1.75rem"
          }
        }
      ],
      "dynamicText": {
        "styleProps": {
          "font-size": "1.875rem",
          "line-height": "2.25rem",
          "padding": "10px 0px 10px 0px",
          "text-align": "center"
        },
        "stylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "stylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "strings": []
      },
      "descriptionsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "descriptionsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptionsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptions": [],
      "buttonsStyleProps": {},
      "buttons": [
        {
          "text": "👨🏻‍💻 Tending Developers",
          "styleProps": {
            "color": "#333333",
            "border-color": "#808080",
            "background-color": "",
            "border-width": "1px",
            "border-radius": "9999px",
            "padding": "20px 40px 20px 40px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "href": "#",
          "openType": "sametab",
          "stylePropsMob": {
            "padding": "10px 20px 10px 20px"
          }
        },
        {
          "text": "🎨 Trending Designers",
          "styleProps": {
            "color": "#333333",
            "border-color": "#808080",
            "background-color": "",
            "border-width": "1px",
            "border-radius": "9999px",
            "padding": "20px 40px 20px 40px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "href": "#",
          "openType": "sametab"
        }
      ],
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "textsStyleProps": {
        "text-align": "center"
      },
      "texts": [],
      "editFormName": "HEADER_FORM_01",
      "metaDataId": 1747639382458,
      "afterIndex": -1,
      "blockId": 1747639382458,
      "textBlock": {
        "descriptions": [
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          },
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          }
        ],
        "headings": [
          {},
          {},
          {},
          {}
        ]
      },
      "fonts": {
        "headings": [
          ""
        ]
      },
      "stylePropsMob": {
        "padding": "40px 20px 40px 20px"
      },
      "stylePropsTab": {
        "padding": "50px 20px 50px 20px"
      }
    },
    {
      "temp": {
        "templateId": 27
      },
      "blockType": "HEADER",
      "blockDesign": "HeaderDesign2",
      "editFormName": "HEADER_04_FORM",
      "styleProps": {
        "background-image": "url('')",
        "background-color": "#ffffff",
        "padding": "60px 20px 60px 20px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#ececec"
      },
      "textBlock": {
        "styleProps": {
          "background-color": "",
          "border-radius": "0",
          "padding": "10px 10px 10px 10px"
        },
        "stylePropsTab": {},
        "stylePropsMob": {},
        "alingBlock": "start",
        "headings": [
          {
            "text": "{{role}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "red",
              "height": "4px"
            },
            "styleProps": {
              "color": "#C3A1C4",
              "font-size": "1.25rem",
              "line-height": "1.75rem",
              "font-weight": "400",
              "font-family-cust": "",
              "font-family": "",
              "border-width": "1px",
              "border-color": "#333333",
              "padding": "10px 20px 10px 20px",
              "border-radius": "9999px",
              "margin": "0px 0px 20px 0px"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "0px 0px 30px 0px",
              "padding": "0px 0px 0px 20px"
            },
            "stylePropsMob": {
              "font-size": "1.125rem",
              "line-height": "1.75rem"
            },
            "stylePropsTab": {
              "font-size": "1.25rem",
              "line-height": "1.75rem"
            }
          },
          {
            "text": "{{name}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "red",
              "height": "1px"
            },
            "styleProps": {
              "color": "#333333",
              "font-size": "3.75rem",
              "line-height": "1",
              "font-family": "",
              "font-weight": "600",
              "font-family-cust": "",
              "font-family-bk": "'Lato', sans-serif"
            },
            "alignStyleProps": {
              "text-align": "left",
              "padding": "10px 20px 10px 20px",
              "margin": "10px 0px 40px 0px"
            },
            "stylePropsMob": {
              "font-size": "2.25rem",
              "line-height": "2.5rem"
            },
            "stylePropsTab": {
              "font-size": "3rem",
              "line-height": "1"
            }
          },
          {
            "text": "{{description}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#8f8f8f",
              "font-size": "1.5rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "padding": "0px 20px 0px 20px"
            },
            "stylePropsTab": {
              "font-size": "1.5rem",
              "line-height": "2rem"
            },
            "stylePropsMob": {
              "font-size": "1.25rem",
              "line-height": "1.75rem"
            }
          }
        ],
        "dynamicText": {
          "styleProps": {
            "color": "#ffffff",
            "font-size": "1.875rem",
            "line-height": "2.25rem",
            "padding": "10px 0px 10px 0px",
            "text-align": "center"
          },
          "stylePropsTab": {
            "padding": "10px 0px 10px 0px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "stylePropsMob": {
            "padding": "10px 0px 10px 0px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "strings": []
        },
        "descriptionsStyleProps": {
          "padding": "10px 0px 10px 0px",
          "text-align": "center",
          "margin": "0px 0px 0px 0px"
        },
        "descriptionsStylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "descriptionsStylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "descriptions": [],
        "buttonsStyleProps": {
          "margin": "50px 0px 0px 0px"
        },
        "buttonAlign": "start",
        "buttons": [],
        "emailSecStyleProps": {},
        "subscription": {
          "showSection": "hide",
          "display": "enable",
          "subConfigs": {
            "configType": "convertkit",
            "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
            "configPlaceholder": ""
          },
          "email_placeholder": {
            "text": "example@mail.com"
          },
          "buttonText": {
            "text": "Subscribe",
            "styleProps": {
              "background-color": "#1b1b31",
              "color": "#ffffff"
            }
          },
          "successMessage": {
            "text": "Thank you for the signup",
            "styleProps": {}
          },
          "errorMessage": {
            "text": "Something went wrong. Please try again.",
            "styleProps": {}
          }
        }
      },
      "imageType": "image",
      "imageVideoPostion": "right",
      "imageBlock": {
        "image": "{{img}}",
        "styleProps": {
          "margin": "20px 20px 20px 20px",
          "border-radius": "0px"
        },
        "outerStyleProps": {
          "border-radius": "1.5rem"
        },
        "tagStyleProps": {
          "border-radius": "1.5rem"
        }
      },
      "videoBlock": {
        "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
        "styleProps": {
          "margin": "20px 20px 20px 20px"
        },
        "videoHeight": {
          "height": "400px"
        }
      },
      "htmlBlock": {
        "value": "",
        "styleProps": {}
      },
      "metaDataId": 1747640329493,
      "afterIndex": -1,
      "blockId": 1747640329493,
      "buttons": [
        {
          "text": "Click Here",
          "styleProps": {
            "color": "#ffffff",
            "border-color": "#3b82f680"
          },
          "href": "#",
          "openType": "sametab"
        }
      ],
      "fonts": {
        "textBlock": ""
      },
      "position": "hide",
      "stylePropsTab": {
        "padding": "50px 20px 50px 20px"
      },
      "stylePropsMob": {
        "padding": "40px 20px 40px 20px"
      }
    },
    {
      "temp": {
        "templateId": 14
      },
      "blockType": "HEADER",
      "blockDesign": "header_01",
      "styleProps": {
        "background-image": "url('')",
        "background-color": "#ffffff",
        "padding": "40px 20px 40px 20px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#ececec"
      },
      "position": "center",
      "headingsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center",
        "max-width": "auto",
        "margin": "4px auto 4px auto"
      },
      "headingsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "headingsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "headings": [
        {
          "text": "Core Skills",
          "styleProps": {
            "font-size": "8rem",
            "line-height": "1",
            "padding": "20px 0px 20px 0px",
            "font-weight": "600",
            "color": "#333333",
            "font-family-cust": "",
            "font-family": "'Lato', sans-serif",
            "margin": "0px 0px 0px 0px",
            "font-family-bk": "'Lato', sans-serif"
          },
          "stylePropsTab": {
            "font-size": "6rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "3.75rem",
            "line-height": "1"
          }
        },
        {
          "text": "{{tags}}",
          "styleProps": {
            "font-size": "1.5rem",
            "line-height": "2rem",
            "color": "#333333",
            "margin": "0px 0px 0px 0px",
            "font-family": "'Lato', sans-serif",
            "font-weight": "500",
            "padding": "20px 0px 40px 0px"
          },
          "stylePropsTab": {
            "font-size": "1.25rem",
            "line-height": "1.75rem"
          },
          "stylePropsMob": {
            "font-size": "1.25rem",
            "line-height": "1.75rem"
          }
        }
      ],
      "dynamicText": {
        "styleProps": {
          "font-size": "1.875rem",
          "line-height": "2.25rem",
          "padding": "10px 0px 10px 0px",
          "text-align": "center"
        },
        "stylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "stylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "strings": []
      },
      "descriptionsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "descriptionsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptionsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptions": [],
      "buttonsStyleProps": {},
      "buttons": [],
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "textsStyleProps": {
        "text-align": "center"
      },
      "texts": [],
      "editFormName": "HEADER_FORM_01",
      "metaDataId": 1747641276864,
      "afterIndex": -1,
      "blockId": 1747641276864,
      "textBlock": {
        "descriptions": [
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          },
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          }
        ],
        "headings": [
          {},
          {}
        ]
      },
      "fonts": {
        "headings": [
          ""
        ]
      },
      "stylePropsMob": {
        "padding": "20px 20px 20px 20px"
      },
      "stylePropsTab": {
        "padding": "30px 20px 30px 20px"
      }
    },
    {
      "temp": {
        "templateId": 30
      },
      "blockType": "HEADER",
      "blockDesign": "header_01",
      "styleProps": {
        "background-image": "url('')",
        "background-color": "#ffffff",
        "padding": "60px 20px 60px 20px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#ececec"
      },
      "position": "center",
      "headingsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center",
        "max-width": "896px",
        "margin": "0px auto 0px 0px"
      },
      "headingsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "headingsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "headings": [
        {
          "text": "🟢 About {{name}}",
          "styleProps": {
            "font-size": "1.25rem",
            "line-height": "1.75rem",
            "padding": "14px 20px 14px 20px",
            "font-weight": "100",
            "color": "#333333",
            "font-family-cust": "",
            "font-family": "'Nunito', sans-serif",
            "margin": "0px 0px 20px 0px",
            "font-family-bk": "'Nunito', sans-serif",
            "text-align": "left",
            "background-color": "#ececec",
            "border-radius": "9999px"
          },
          "stylePropsTab": {
            "font-size": "1.25rem",
            "line-height": "1.75rem"
          },
          "stylePropsMob": {
            "font-size": "1.125rem",
            "line-height": "1.75rem"
          },
          "alignStyleProps": {
            "text-align": "left",
            "background-color": ""
          }
        },
        {
          "text": "{{content}}",
          "styleProps": {
            "font-size": "2.25rem",
            "line-height": "2.5rem",
            "padding": "20px 0px 20px 0px",
            "font-weight": "100",
            "color": "#333333",
            "font-family-cust": "",
            "font-family": "'Nunito', sans-serif",
            "margin": "0px 0px 0px 0px",
            "font-family-bk": "'Nunito', sans-serif",
            "text-align": "left"
          },
          "stylePropsTab": {
            "font-size": "3rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "2.25rem",
            "line-height": "2.5rem"
          }
        }
      ],
      "dynamicText": {
        "styleProps": {
          "font-size": "1.875rem",
          "line-height": "2.25rem",
          "padding": "10px 0px 10px 0px",
          "text-align": "center"
        },
        "stylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "stylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "strings": []
      },
      "descriptionsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "descriptionsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptionsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptions": [],
      "buttonsStyleProps": {},
      "buttons": [],
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "textsStyleProps": {
        "text-align": "center"
      },
      "texts": [],
      "editFormName": "HEADER_FORM_01",
      "metaDataId": 1747640845112,
      "afterIndex": -1,
      "blockId": 1747640845112,
      "textBlock": {
        "descriptions": [
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          },
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          }
        ],
        "headings": [
          {},
          {}
        ]
      },
      "fonts": {
        "headings": [
          ""
        ]
      },
      "stylePropsMob": {
        "padding": "60px 20px 60px 20px"
      },
      "stylePropsTab": {
        "padding": "70px 20px 70px 20px"
      },
      "containerStyleProps": {
        "padding": "0px 0px 0px 0px"
      },
      "containerStylePropsTab": {
        "padding": "0px 00px 0px 00px"
      }
    },
    {
      "temp": {
        "templateId": 29
      },
      "blockType": "HEADER",
      "blockDesign": "header_01",
      "styleProps": {
        "background-image": "url('')",
        "background-color": "#ffffff",
        "padding": "120px 20px 120px 20px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#ececec"
      },
      "position": "center",
      "headingsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center",
        "max-width": "1280px",
        "margin": "4px auto px 4px auto px"
      },
      "headingsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "headingsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "headings": [
        {
          "text": "<span style=\"color:#7DE5BA\">Contact</span> {{name}}",
          "styleProps": {
            "font-size": "3.75rem",
            "line-height": "1",
            "padding": "20px 0px 60px 0px",
            "font-weight": "400",
            "color": "#333333",
            "font-family-cust": "",
            "font-family": "'Lato', sans-serif",
            "margin": "0px 0px 0px 0px",
            "font-family-bk": "'Lato', sans-serif",
            "text-align": "left"
          },
          "stylePropsTab": {
            "font-size": "3.75rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "3rem",
            "line-height": "1"
          }
        },
        {
          "text": "{{email}} <br/> {{facebook}}",
          "styleProps": {
            "font-size": "1.5rem",
            "line-height": "2rem",
            "color": "#333333"
          }
        }
      ],
      "dynamicText": {
        "styleProps": {
          "font-size": "1.875rem",
          "line-height": "2.25rem",
          "padding": "10px 0px 10px 0px",
          "text-align": "center"
        },
        "stylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "stylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "strings": []
      },
      "descriptionsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "descriptionsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptionsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptions": [],
      "buttonsStyleProps": {},
      "buttons": [],
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "textsStyleProps": {
        "text-align": "center"
      },
      "texts": [],
      "editFormName": "HEADER_FORM_01",
      "metaDataId": 1747641596147,
      "afterIndex": -1,
      "blockId": 1747641596147,
      "textBlock": {
        "descriptions": [
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          },
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          }
        ],
        "headings": [
          {},
          {}
        ]
      },
      "fonts": {
        "headings": [
          ""
        ]
      },
      "stylePropsMob": {
        "padding": "60px 20px 60px 20px"
      },
      "stylePropsTab": {
        "padding": "80px 20px 80px 20px"
      },
      "containerStyleProps": {
        "padding": "0px 20px 0px 20px"
      },
      "containerStylePropsTab": {
        "padding": "0px 00px 0px 00px"
      }
    },
    {
      "blockType": "CTA",
      "blockDesign": "CTADesign1",
      "editFormName": "CTA_01_FORM",
      "styleProps": {
        "background-color": "#ffffff",
        "padding": "120px 0px 120px 0px"
      },
      "headings": [
        {
          "text": "Explore More Top Developers\n",
          "styleProps": {
            "text-align": "center",
            "font-size": "8rem",
            "line-height": "1",
            "padding": "50px 0px 30px 0px",
            "color": "#333333",
            "font-family-cust": "",
            "font-family": "'Nunito', sans-serif",
            "font-family-bk": "'Nunito', sans-serif"
          },
          "alignStyleProps": {
            "text-align": "center"
          },
          "stylePropsTab": {
            "font-size": "3rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "2.25rem",
            "line-height": "2.5rem"
          }
        },
        {
          "text": "Discover more talented developers who can bring your projects to life. Browse our curated list of experts in various technologies and industries.",
          "styleProps": {
            "text-align": "center",
            "padding": "10px 0px 10px 0px",
            "color": "#333333",
            "font-size": "1.25rem",
            "line-height": "1.75rem",
            "margin": "0px 0px 40px 0px",
            "border-color": ""
          },
          "alignStyleProps": {
            "text-align": "center"
          }
        }
      ],
      "showBtnSec": true,
      "btnSecStyleProps": {},
      "btnSecStylePropsTab": {},
      "btnSecStylePropsMob": {},
      "buttons": [
        {
          "text": "➤ View More Developers",
          "alt": "Click Here",
          "href": "https://yahoo.com",
          "styleProps": {
            "background-color": "#333333",
            "color": "#ffffff",
            "border-color": "#3b82f680",
            "border-radius": "9999px",
            "padding": "14px 40px 14px 40px",
            "border-width": "0px"
          },
          "openType": "sametab"
        },
        {
          "text": "Explore Our Talent Pool",
          "styleProps": {
            "color": "#333333",
            "border-color": "#333333",
            "background-color": "",
            "border-width": "1px",
            "border-radius": "9999px",
            "padding": "14px 40px 14px 40px"
          },
          "href": "",
          "openType": "sametab"
        }
      ],
      "showEmailSec": true,
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "metaDataId": 1747642400824,
      "afterIndex": 5,
      "blockId": 1747642400824,
      "containerStyleProps": {
        "padding": "0px 20px 0px 20px",
        "max-width": "998px"
      },
      "containerStylePropsTab": {
        "padding": "0px 0px 0px 0px"
      },
      "fonts": {
        "headings": [
          ""
        ]
      }
    }
  ]
}